import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import { store } from './redux';
import { AppState } from './redux/app.reducer';

const render = () => ReactDOM.render(
  <Provider store={store}>
    <App state={(store.getState() as {app: AppState}).app} />
  </Provider>,
  document.getElementById('root') as HTMLElement
);

render();
// need to get rid of this, `Provider` does this internally
store.subscribe(render);



// WEBPACK FOOTER //
// ./src/index.tsx